<template>
  <div class="mask" @click.self="close">
    <div class="charalist">
      <ul>
        <li class="back" @click="setdata('back')"></li>
        <li
          v-for="(value, index) in filter"
          :key="value.Name + index"
          :style="{
            'background-image':
              'url(\'/static/img/weapons/' +
              value.Name +
              '.png\'),url(\'/static/img/weapons/' +
              value.Bg +
              '.png\')',
          }"
          :title="value.Name"
          @click="setdata(index)"
        >
          <p>{{ value.Name }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Weapons",
  data() {
    return {
      weapons_list: [],
    };
  },
  props: ["type"],
  created: function () {
    this.axios
      .get("weapons.json")
      .then((response) => {
        this.weapons_list.splice(0, this.weapons_list.length);
        for (let i = 0; i < response.data.Weapons_list.length; i++) {
          this.weapons_list.push(response.data.Weapons_list[i]);
        }
      })
      .catch((e) => {
        alert(e);
      });
  },
  methods: {
    setdata: function (index) {
      if (index == "back") {
        this.$emit("selected", "back");
      } else {
        this.$emit("selected", this.filter[index]);
      }
    },
    close: function () {
      this.$emit("close");
    },
  },
  computed: {
    filter: function () {
      let type = this.type;
      let arr = [];
      if (type == null) {
        arr = this.weapons_list;
      } else {
        arr = this.weapons_list.filter(function (item) {
          if (type[0].length > 1) {
            for (let i = 0; i < type[0].length; i++) {
              if (item.Type == type[0][i]) {
                return true;
              }
            }
          }
          if (item.Type == type) {
            return true;
          }
        });
      }
      arr.sort(function (x, y) {
        if (x.Type < y.Type) {
          return 1;
        }
        if (x.Type > y.Type) {
          return -1;
        }
        if (x.Bg < y.Bg) {
          return 1;
        }
        if (x.Bg > y.Bg) {
          return -1;
        }
      });
      return arr;
    },
  },
};
</script>

<style scoped lang="scss">
.mask {
  width: 100%;
  height: 100%;
  background: rgba(150, 150, 150, 0.5);
  position: absolute;
  top: 0;
  left: 0;
}
.charalist {
  margin: 0 auto;
  background: rgba(50, 50, 50, 0.8);
  width: 90%;
  max-width: 720px;
  padding: 5px;
  margin-top: 10%;
  border: solid 0.5px #f0f0f0;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      cursor: pointer;
      position: relative;
      width: 12%;
      color: #f0f0f0;
      background-size: contain, cover;
      background-position: center center, center center;
      background-repeat: no-repeat, no-repeat;
      border-radius: 3px;
      transition: 0.1s;
      margin: 2px 0.25% 2px 0.25%;
      border: solid 1px #f0f0f0;
      &::before {
        content: "";
        display: block;
        padding-top: 100%;
      }
      &.back {
        background-image: url("/static/img/weapons/btn_back.png");
        border: solid 1px #f0f0f0;
      }
      p {
        padding: 2px 1px;
        position: absolute;
        bottom: 5%;
        width: 100%;
        text-align: center;
        font-size: 70%;
        text-overflow: ellipsis; /* 幅を超えた部分を...にする */
        white-space: nowrap; /* 改行しない */
        overflow: hidden;
        background: rgba(50, 50, 50, 0.8);
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .charalist {
    width: 100%;
    ul {
      li {
        width: 19%;
        margin: 2px 0.5% 2px 0.5%;
      }
    }
  }
}
</style>